import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../images/ArrowRight.svg";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { useLazyQuery } from "@apollo/client";
import { DashboardVars, GetDashboardTicketCountData } from "./types";
import { GetDashboardTicketCount } from "./queries";
import OpenTicket from "../../../../../images/dashboard/Open Tickets.svg";
import LowPriorityTicket from "../../../../../images/dashboard/Low Priority Tickets.svg";
import HighPriorityTicket from "../../../../../images/dashboard/High Priority Tickets.svg";
import Unassigned from "../../../../../images/dashboard/Un-Assign Tickets.svg";
import NotFixed from "../../../../../images/dashboard/Not FixedTickets.svg";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import {
  LicenseTypes,
  MapPageFor,
  PriorityEnum,
} from "../../../../../utils/Enum.types";
import { TicketStatus, pollingMinutes } from "../../../../../utils/constants";
import TicketRaisedListIndex from "../../maps/ticketdetails/TicketRaisedListIndex";
import TicketDetailsGraph from "./view/GraphWise/TicketDetails";
const TicketDetails = () => {
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const [modalState, setModalState] = useState({
    Open: false,
    Assigned: false,
    Resolved: false,
    Closed: false,
    Reopened: false,
    Low: false,
    Medium: false,
    Critical: false,
  });
  const toggleModal = (key: keyof typeof modalState) => {
    setModalState((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const [GetDashboardTickets, { data, loading, fetchMore }] = useLazyQuery<
    GetDashboardTicketCountData,
    DashboardVars
  >(GetDashboardTicketCount,{
    pollInterval: pollingMinutes
  });
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardTickets({
        variables: {
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0,
        },
      });
    }
  }, [customer_id, user_details.id, GetDashboardTickets]);

  const ticketImages = {
    Open: OpenTicket,
    Low: LowPriorityTicket,
    High: HighPriorityTicket,
    Unassigned: Unassigned,
    Default: NotFixed,
  };

  const ticketStatusMap = {
    Open: TicketStatus.OPEN,
    Assigned: TicketStatus.ASSIGNED,
    Resolved: TicketStatus.RESOLVED,
    Closed: TicketStatus.CLOSED,
    Reopened: TicketStatus.RE_OPENED,
  };

  const ticketPriorityMap = {
    Low: PriorityEnum.LOW,
    Medium: PriorityEnum.MEDIUM,
    Critical: PriorityEnum.CRITICAL,
  };

  return (
    <>
      <div className="d-ticket-details">
        <div className="d-ticket-details--details">
          <b className="d-main-page__block--title">Ticket Details</b>
          <ul className="d-ticket-details__ul">
            {data ? (
              data.GetDashboardTicketCount.map((res, index) => (
                <li
                  key={index}
                  onClick={() =>
                    toggleModal(res.desc as keyof typeof modalState)
                  }
                >
                  <div className="d-ticket-details--flex">
                    <span>{index + 1}.</span>
                    <img
                      src={
                        ticketImages[res.desc as keyof typeof ticketImages] ||
                        ticketImages.Default
                      }
                      alt="/"
                    />
                    <label>{res.desc}</label>
                  </div>
                  <div className="d-ticket-details--flex">
                    <b>{res.count}</b>
                    <img src={RightArrow} alt="" />
                  </div>
                </li>
              ))
            ) : (
              <b className="nodata">No data found</b>
            )}
          </ul>

          {Object.keys(modalState).map((key) => (
            <CustomModal
              key={key}
              style={AddModalStyles}
              isOpen={modalState[key as keyof typeof modalState]}
              onRequestClose={() => toggleModal(key as keyof typeof modalState)}
              contentComponent={
                <TicketRaisedListIndex
                  NavType={LicenseTypes.SUBSIDIARY}
                  pageFor={MapPageFor.MODAL}
                  ticketStatusType={
                    ticketStatusMap[key as keyof typeof ticketStatusMap] ||
                    TicketStatus.ALL
                  }
                  setModalFlag={() =>
                    toggleModal(key as keyof typeof modalState)
                  }
                  ticketPriority={
                    ticketPriorityMap[key as keyof typeof ticketPriorityMap] ||
                    PriorityEnum.ALL
                  }
                />
              }
            />
          ))}
        </div>
        <TicketDetailsGraph />
      </div>
    </>
  );
};

export default TicketDetails;
